import { render, staticRenderFns } from "./NetIntro.vue?vue&type=template&id=0837a641&scoped=true&"
import script from "./NetIntro.vue?vue&type=script&lang=js&"
export * from "./NetIntro.vue?vue&type=script&lang=js&"
import style0 from "./NetIntro.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NetIntro.vue?vue&type=style&index=1&id=0837a641&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837a641",
  null
  
)

export default component.exports